import { render } from "./EditProductGroup.vue?vue&type=template&id=6d6c341d&ts=true"
import script from "./EditProductGroup.vue?vue&type=script&lang=ts"
export * from "./EditProductGroup.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__